import Empty from '@/components/Search/Empty';
import CustomSpin from '@/components/UI/CustomSpin';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { getDownloadCatagoryTree, getDownloadInfo } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { Collapse, Popover, Select } from 'antd';
import styles from './index.module.scss';

export default function Download() {
    const { Link, useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('supportdownloadproduct');
    const { locale } = useRouter();
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectOpen, setSelectOpen] = useState(false);
    const [menuData, setMenuData] = useState([]);
    const powerKitsId = '1514858700785975298';
    const [defaultActiveId, setDefaultActiveId] = useState(-1);
    const [level3Catagories, setLevel3Catagories] = useState([]);
    const [popShow, setPopShow] = useState(false);
    const [mainSelectorValue, setMainSelectorValue] = useState('');
    const [subSelectorValue, setSubSelectorValue] = useState('');
    const [activeId, setActiveId] = useState('');

    // 获取左边树结构，只需要power kits的数据
    const getMenuData = async () => {
        try {
            const res = await getDownloadCatagoryTree(locale as string);
            if (res?.code === '0') {
                const data = res?.data?.filter((item: Record<string, any>) => item.downloadCatagoryId === powerKitsId);
                setMenuData(data);
                return data;
            }
        } catch (e) {
            setMenuData([]);
            return [];
        }
    };

    const getDataList = async (id: string | number, keyName?: string) => {
        setLoading(true);
        const params: Record<string, string | number> = { size: 1000 };
        params[keyName || 'productCatagoryIds'] = id;
        try {
            const res = await getDownloadInfo({ ...params });
            if (res.code === '0') {
                setFileList(res?.data?.content || []);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setFileList([]);
        }
    };

    const getSubMenu = (data: any[], id: string, isInit = false) => {
        data.forEach((item: Record<string, any>) => {
            if (item.downloadCatagoryId !== id) {
                getSubMenu(item?.subs || [], id, isInit);
            } else {
                setLevel3Catagories(item.subs || []);
                if (isInit) {
                    setSubSelectorValue(item.subs[0]?.name || '');
                    getDataList(item?.subs[0]?.downloadCatagoryId || '', 'spuIds').catch(console.error);
                }
            }
        });
    };

    const handleVisibleChange = (visible: boolean) => {
        setPopShow(visible);
    };

    const changeMenuData = (id: string | string[]) => {
        setActiveId(id);
    };

    const tabChange = (value: any) => {
        setSelectOpen(false);
        getDataList(value, 'spuIds').catch(console.error);
        setSubSelectorValue(level3Catagories.filter((item: any) => item.downloadCatagoryId === value)[0]?.name);
    };

    const onOk = () => {
        getSubMenu(menuData, activeId, true);
        setPopShow(false);
    };

    useEffect(() => {
        getMenuData().then((res) => {
            setMainSelectorValue(res[0]?.name);
            getSubMenu(res[0]?.subs || [], res[0]?.subs[0]?.downloadCatagoryId || '', true);
        });
    }, []);

    return (
        <div className={styles.powerKitsDownload}>
            <div className="downloadBox">
                {Array.isArray(fileList) && fileList?.length > 0 && (
                    <div className="selectorBox">
                        <div className="leftSelector">
                            <Popover
                                overlayClassName="download-dropdown-h5"
                                placement="bottom"
                                content={
                                    <div className="downloadPopoverBox">
                                        <div className="categoryLists">
                                            <Collapse
                                                expandIconPosition={'right'}
                                                accordion
                                                ghost
                                                destroyInactivePanel
                                                defaultActiveKey={[1]}
                                                expandIcon={({ isActive }) => (
                                                    <div className="minusPlusIconBox">
                                                        <Image
                                                            src={isActive ? '/icons/mobileH5/minus_black_h5.svg' : '/icons/mobileH5/plus_black_h5.svg'}
                                                            layout="fill"
                                                            className="fullImgs"
                                                            alt={isActive ? t('support.download.minus') : t('support.download.plus')}
                                                        />
                                                    </div>
                                                )}
                                            >
                                                {menuData?.map((category: any) => (
                                                    <Collapse.Panel
                                                        header={category.name}
                                                        key={category.downloadCatagoryId}
                                                        showArrow={category?.subs?.length > 0}
                                                    >
                                                        {category?.subs?.length > 0 && (
                                                            <div className="subLists">
                                                                <Collapse accordion ghost defaultActiveKey={[1]} onChange={changeMenuData}>
                                                                    {category?.subs?.map((sub: any) => (
                                                                        <Collapse.Panel header={sub.name} key={sub.downloadCatagoryId} showArrow={false} />
                                                                    ))}
                                                                </Collapse>
                                                            </div>
                                                        )}
                                                    </Collapse.Panel>
                                                ))}
                                            </Collapse>
                                        </div>
                                        <div className="btnBox">
                                            <div className="okBtn" onClick={onOk}>
                                                {t('common.confirm_text')}
                                            </div>
                                        </div>
                                    </div>
                                }
                                trigger="click"
                                visible={popShow}
                                onVisibleChange={handleVisibleChange}
                            >
                                <div className="leftSelectText font-family-semibold">
                                    {mainSelectorValue}
                                    <div className="iconBox" style={{ top: !mainSelectorValue ? '-0.13rem' : '0.005rem' }}>
                                        <EFArrowDown
                                            style={{
                                                fontSize: '.12rem',
                                                marginTop: '0.03rem',
                                                marginLeft: '0.03rem',
                                            }}
                                        />
                                    </div>
                                </div>
                            </Popover>
                        </div>
                        <div className="rightSelector">
                            <Select
                                className="download_selector_h5"
                                value={subSelectorValue}
                                suffixIcon={() => (
                                    <div className={`iconBox ${selectOpen ? 'selectOpen' : ''}`}>
                                        <EFArrowDown
                                            style={{
                                                fontSize: '.12rem',
                                                marginTop: '0.03rem',
                                                color: '#000',
                                            }}
                                        />
                                    </div>
                                )}
                                onChange={tabChange}
                                // onDropdownVisibleChange={changeVisibleDropdown}
                            >
                                {level3Catagories.length > 0 &&
                                    level3Catagories?.map((catagory: any) => (
                                        <Select.Option value={catagory.downloadCatagoryId} key={catagory.downloadCatagoryId}>
                                            {catagory.name}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </div>
                    </div>
                )}
                <CustomSpin
                    loading={loading}
                    customStyle={{
                        position: 'relative',
                        left: '0.2rem',
                        top: '0.2rem',
                    }}
                />
                <ul className="downloadListBox" style={{ opacity: loading ? 0 : 1 }}>
                    {Array.isArray(fileList) &&
                        fileList?.map((file: any, k: number) => (
                            <li className="fileList" key={k}>
                                <div className="fileContent">
                                    <p className="fillTitle font-family-medium">{file.title}</p>
                                    <p className="fileDate font-family-medium">{file.updateTime}</p>
                                </div>
                                <Link href={file.fileUrl} ariaLabel={file.classify === 'MANUAL' ? s('Download PDF') : s('Play video')}>
                                    <div className="donwnLoadBtn font-family-semibold">
                                        <div className="downLoadIcon">
                                            <Image
                                                src={file.classify === 'MANUAL' ? '/img/download/download-icon.svg' : '/img/download/play.svg'}
                                                layout="fill"
                                                alt={file.classify === 'MANUAL' ? t('support.download.download_icon') : t('support.download.play_icon')}
                                            />
                                        </div>
                                        {file.classify === 'MANUAL' ? 'PDF' : 'Video'}
                                    </div>
                                </Link>
                            </li>
                        ))}
                </ul>
                {/* 无数据情况 */}
                {(!Array.isArray(fileList) || fileList?.length === 0) && <Empty isMobile />}
            </div>
        </div>
    );
}
